// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4nBWr","col":"styles_col__2cI-p"};